import { render, staticRenderFns } from "./Neighborhood.vue?vue&type=template&id=954c15a6"
import script from "./Neighborhood.vue?vue&type=script&lang=js"
export * from "./Neighborhood.vue?vue&type=script&lang=js"
import style0 from "./Neighborhood.vue?vue&type=style&index=0&id=954c15a6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports